import React, {useEffect} from "react";
import { Block, BlockContent, BlockDes, BlockHead, BlockTitle } from "../../components/Component";
import Logo from "../../images/logo.png";
import LogoDark from "../../images/logo-dark.png";
import PageContainer from "../../layout/page-container/PageContainer";
import Head from "../../layout/head/Head";
import AuthFooter from "./AuthFooter";
import { Link, useLocation } from "react-router-dom";
// import config from "../../config/config";
import { loginAxios } from '../../config/axios.config';
import axios from "axios";
import { useQuery, useMutation } from "@tanstack/react-query";

const PoSuccess = () => {

  let { search } = useLocation();
  const query = new URLSearchParams(search);

  const paramID = query.get('id');
  const paramToken = query.get('token');
  const type = query.get('type');



  const getSizes = async (params) => {

    let URL = '';

    if(type) {
        URL = `designers/po/recived_po/?poId=${paramID}&token=${paramToken}&type=${type}`
    } else {
        URL = `designers/po/recived_po/?poId=${paramID}&token=${paramToken}`
    }

    console.log(URL);

    try {
      const { data } = await loginAxios.get(URL, {
        headers: {
          'x-auth-token': localStorage.getItem('accessToken')
        }
      });
      return data;

    } catch (error) {
      return Promise.reject(error);
    }
  };


//   const poRecieved = async (param) => {
//     try {
//         let URL = '';

//         if(type) {
//           URL = `${loginAxios}purchase_order/po/recived_po/?poId=${paramID}&token=${paramToken}&type=${type}`
//         } else {
//           URL = `${loginAxios}purchase_order/po/recived_po/?poId=${paramID}&token=${paramToken}`
//         }
//         const { data } = await axios.get(URL, {
//             headers: {
//                 'x-auth-token': localStorage.getItem('accessToken')
//             }
//         });
//         return data;
//     } catch (error) {
//         return Promise.reject(error);
//     }
// };

const poRecievedCall = useMutation(getSizes, {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    onSettled(data, error) {
        if (data) {            
            // setData(data?.data);
        }
    }
});

useEffect(() => {
    poRecievedCall.mutate()    
}, [])

  return (
    <React.Fragment>
      <Head title="Success" />
      <PageContainer>
        <Block className="nk-block-middle nk-auth-body">
          {/* <div className="brand-logo pb-5">
            <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
              <img className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" />
              <img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" />
            </Link>
          </div> */}
          <BlockHead>
            <BlockContent>
              <BlockTitle tag="h4">Thank you for confirming this Purchase Order.</BlockTitle>
              {/* <BlockDes className="text-success">
                <p>PO RECEIVED</p>
              </BlockDes> */}
            </BlockContent>
          </BlockHead>
        </Block>
        <AuthFooter />
      </PageContainer>
    </React.Fragment>
  );
};
export default PoSuccess;
